import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {

  transform(value: any): any {
    let keys = [];
    for ( let key in value ) {
      keys.push(key)
    }
    return keys;
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/pipes/keys.pipe.ts